// Approximate city centres for distance sorting when the user picks a city
// manually (no GPS). Covers HCEN's primary service areas in AP/Telangana.
export const CITY_CENTROIDS = {
  tirupati:    { lat: 13.6288, lng: 79.4192 },
  kadapa:      { lat: 14.4673, lng: 78.8242 },
  cuddapah:    { lat: 14.4673, lng: 78.8242 },
  chittoor:    { lat: 13.2172, lng: 79.1003 },
  nellore:     { lat: 14.4426, lng: 79.9865 },
  kurnool:     { lat: 15.8281, lng: 78.0373 },
  guntur:      { lat: 16.3067, lng: 80.4365 },
  vijayawada:  { lat: 16.5062, lng: 80.6480 },
  visakhapatnam: { lat: 17.6868, lng: 83.2185 },
  hyderabad:   { lat: 17.3850, lng: 78.4867 },
  bengaluru:   { lat: 12.9716, lng: 77.5946 },
  chennai:     { lat: 13.0827, lng: 80.2707 },
  mumbai:      { lat: 19.0760, lng: 72.8777 },
  delhi:       { lat: 28.6139, lng: 77.2090 },
  warangal:    { lat: 17.9689, lng: 79.5941 },
  anantapur:   { lat: 14.6819, lng: 77.6006 },
  rajahmundry: { lat: 17.0005, lng: 81.8040 },
  kakinada:    { lat: 16.9891, lng: 82.2475 },
};

export function coordsForCity(cityName) {
  if (!cityName) return null;
  const key = cityName.toLowerCase().trim()
    .replace(/\s+/g, ' ')
    .replace(/[()]/g, '');
  // Direct match
  if (CITY_CENTROIDS[key]) return CITY_CENTROIDS[key];
  // Partial match (e.g. "Tirupati (Urban)" → tirupati)
  for (const [name, coords] of Object.entries(CITY_CENTROIDS)) {
    if (key.includes(name) || name.includes(key)) return coords;
  }
  return null;
}
